<template>
  <b-modal :active.sync="isTargetModalActive" class="target-modal">
    <div class="card has-text-centered">
      <div class="card-header">
        <p class="card-header-title is-centered">
          Daily Target
        </p>
      </div>
      <div class="card-content">
        <div class="current-target">
          <div class="columns is-centered">
            <div class="column is-4">
              <b-progress
                :value="target.currentDailyRecordings"
                :max="target.targetDailyRecordings"
                size="is-medium"
                type="is-info"
                show-value
              >
                {{ target.currentDailyRecordings }} /
                {{ target.targetDailyRecordings }} recordings
              </b-progress>
            </div>
            <div class="column is-4">
              <b-progress
                :value="target.currentDailySeconds"
                :max="target.targetDailySeconds"
                size="is-medium"
                type="is-info"
                show-value
              >
                {{ target.currentDailySeconds }} /
                {{ target.targetDailySeconds }} seconds
              </b-progress>
            </div>
            <div class="column is-4">
              <b-progress
                :value="target.currentDailySpellings"
                :max="target.targetDailySpellings"
                size="is-medium"
                type="is-info"
                show-value
              >
                {{ target.currentDailySpellings }} /
                {{ target.targetDailySpellings }} words
              </b-progress>
            </div>
          </div>
        </div>
        <br />
        <div class="content">
          <p class="subtitle">
            Set a daily target that will keep you motivated.
          </p>
          <div class="columns is-centered">
            <div class="column is-4">
              <b-field label="Target recordings per day">
                <b-numberinput
                  :min="minDailyParagraphs"
                  type="is-info"
                  v-model="targetDailyRecordingsValue"
                >
                </b-numberinput>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field label="Target seconds of reading per day">
                <b-numberinput
                  :min="minDailySeconds"
                  type="is-info"
                  v-model="targetDailySecondsValue"
                >
                </b-numberinput>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field label="Target dictation words per day">
                <b-numberinput
                  :min="minDailySpellings"
                  type="is-info"
                  v-model="targetDailySpellingsValue"
                >
                </b-numberinput>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-12">
              <b-button type="is-info" @click="save" expanded>Save</b-button>
            </div>
          </div>
          <p class="subtitle is-size-7" v-if="!this.oidcIsAuthenticated">
            You are currently not signed in. This setting, as well as any
            activity you accumulate towards the target will be lost when you
            navigate away from the site. If you want to keep your recordings and
            track your progress please
            <a @click="signIn" class="has-text-weight-bold">sign in</a>.
          </p>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";
import authMixin from "@/mixins/authMixin";
import {
  MIN_DAILY_RECORDINGS,
  MIN_DAILY_SECONDS,
  MIN_DAILY_SPELLINGS
} from "../store/constants";
export default {
  mixins: [authMixin],
  props: ["target"],
  data() {
    return {
      isTargetModalActive: false,
      minDailyParagraphs: MIN_DAILY_RECORDINGS,
      minDailySeconds: MIN_DAILY_SECONDS,
      minDailySpellings: MIN_DAILY_SPELLINGS,
      targetDailyRecordingsValue: this.target.targetDailyRecordings,
      targetDailySecondsValue: this.target.targetDailySeconds,
      targetDailySpellingsValue: this.target.targetDailySpellings
    };
  },
  methods: {
    ...mapActions(["updateTarget"]),
    toggle() {
      this.targetDailyRecordingsValue = this.target.targetDailyRecordings;
      this.targetDailySecondsValue = this.target.targetDailySeconds;
      this.targetDailySpellingsValue = this.target.targetDailySpellings;
      this.isTargetModalActive = !this.isTargetModalActive;
    },
    async save() {
      if (
        this.targetDailySecondsValue < MIN_DAILY_SECONDS ||
        this.targetDailyRecordingsValue < MIN_DAILY_RECORDINGS ||
        this.targetDailySpellingsValue < MIN_DAILY_SPELLINGS
      )
        return;
      const newTarget = {
        targetDailyRecordings: this.targetDailyRecordingsValue,
        targetDailySeconds: this.targetDailySecondsValue,
        targetDailySpellings: this.targetDailySpellingsValue
      };
      await this.updateTarget(newTarget);
      this.toggle();
    }
  },
  mounted() {
    this.$root.$on("toggleTargetModal", this.toggle);
  }
};
</script>

<style lang="scss" scoped></style>
